import CustomImage from '../../fragments/custom-image/CustomImage';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import List from '../../fragments/list/List';
import Stat from '../../fragments/stat/Stat';

import ComponentHeading from '../../fragments/heading/ComponentHeading';
import RichText from '../../fragments/rich-text/RichText';

export default function ContentMediaHigh({ block, index }) {
  if (!block) return null;

  const HeadingTag = index === 0 ? 'h1' : 'h2';

  const onlyContent = block.heading || block.image;

  return (
    <ComponentWrapper
      block={block}
      className={`ContentMediaHigh image--${block.imagePlacement}`}
    >
      {(block.largeHeading || block.smallHeading) && (
        <div className={'l-grid'}>
          <ComponentHeading
            heading={block.largeHeading}
            subheading={block.smallHeading}
            cta={block.cta}
          />
        </div>
      )}
      <div className={'l-grid'}>
        <div className={`l-grid__col l-grid__col--m-${onlyContent ? 5 : 6}-12`}>
          {block.heading ? (
            <HeadingTag
              className={`ContentMediaHigh-heading h5`}
              dangerouslySetInnerHTML={{ __html: block.heading }}
            />
          ) : (
            <>
              {block.content && !block.image && (
                <div className="ContentMediaHigh-content">
                  <RichText html={block.content} />
                </div>
              )}
            </>
          )}
          {block.imagePlacement == 'left' && block.image && (
            <div className="ContentMediaHigh-media">
              <CustomImage
                image={block.image}
                fill={true}
                parallax
                desktopWidth={50}
              />
            </div>
          )}
        </div>

        <div
          className={'l-grid__col l-grid__col--m-5-12 l-grid__col--m-push-1-12'}
        >
          <div className="ContentMediaHigh-text">
            {(block.heading || block.image) && block.content && (
              <div className="ContentMediaHigh-content">
                <RichText html={block.content} />
              </div>
            )}

            {block.list?.length > 0 && (
              <List items={block.list} heading={block.listHeading} />
            )}
            {block.stat && (
              <Stat stat={block.stat} heading={block.statHeading} />
            )}

            {block.imagePlacement == 'right' && block.image && (
              <div className="ContentMediaHigh-media">
                <CustomImage
                  image={block.image}
                  fill={true}
                  parallax
                  desktopWidth={50}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
}
